import Cookies from "js-cookie";
import { getJson } from "../../../shared/api/httpClient";

// Pide al backend una URL firmada temporal para un destino externo (Media Kit,
// Weddings, etc.). El endpoint solo lee `url`; el agente lo resuelve desde la
// sesión ($this->_Id_Agent), por eso mandamos también UserAccessToken +
// DeviceAccessToken como el resto de llamadas autenticadas (ver trackRedeemApi).
export async function generateTemporalUrlSignature(targetUrl) {
  const jsonResponse = await getJson("GenerateTemporalUrlSignature", {
    url: targetUrl,
    UserAccessToken: Cookies.get("UserAccessToken"),
    DeviceAccessToken: Cookies.get("DeviceAccessToken"),
    RegisterType: "Agent",
  }, {
    errorMessage: "No se pudo generar la URL temporal.",
  });

  // El PHP responde { result: true, url: signedUrl }.
  return jsonResponse.url || targetUrl;
}
